import {RecordForm} from '../forms/RecordForm';


import {useMessage} from '../hooks/useMessage';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useMessage();

    if (!record) {
        return null;
    }

    return (
        <FormPageLayout
            title='Add Message'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
